import {Injectable, OnDestroy} from '@angular/core';
import {AbstractFindAllService} from '../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {AccountingAccountModel} from '../entity/accountingAccount.model';
import {AccountingAccountRepository} from '../../impl/service/ngrx/accountingAccount.repository';
import {AccountingAccountDataServiceAdapter} from '../../impl/service/ngrx/accountingAccountDataService.adapter';

@Injectable()
export class AccountingAccountFindAllService
    extends AbstractFindAllService<AccountingAccountModel, AccountingAccountModel> implements OnDestroy{

    constructor(repository: AccountingAccountRepository, dataServiceAdapter: AccountingAccountDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
